import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs, FilterSettingsModel, IFilter, PageSettingsModel } from '@syncfusion/ej2-grids';
import { SignaturePad } from 'angular2-signaturepad';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { clientTemplate } from '../agreement-template/agreement-template.model';
import { Additional_AppointeeAddressTemplateBO, Application_Employer_Identification_NumberTemplateBO, ClientAgreementTemplateBO, ClientAgreementTemplateMergedBO, EmployerOrPayerAppointmentOfAgentTemplateBO, functionpermission, Individual_Sole_Proprietor_OfAttornyTemplateBO, ParticipantAgreementTemplateBO, prepopulate, Release_of_InformationTemplateBO } from './clienttemplate.model';
import { clienttemplateService } from './clienttemplate.service';

@Component({
  selector: 'app-clienttemplate',
  templateUrl: './clienttemplate.component.html',
  styleUrls: ['./clienttemplate.component.scss']
})


export class ClienttemplateComponent implements OnInit {
  @Input() ClientTemplateBO: clientTemplate = new clientTemplate();
  @Output() dataEmitTemplate = new EventEmitter<clientTemplate>();

  private onDestroy$: Subject<void> = new Subject<void>();
  agreementBO = new ParticipantAgreementTemplateBO();
  OnboardClientDocumentBO = new ClientAgreementTemplateMergedBO()
  indivual = new Individual_Sole_Proprietor_OfAttornyTemplateBO();
  onboardClientDocument = new ClientAgreementTemplateBO();
  application = new Application_Employer_Identification_NumberTemplateBO();
  payer = new EmployerOrPayerAppointmentOfAgentTemplateBO();
  fp:functionpermission=new functionpermission();
  prepolate: prepopulate = new prepopulate();
  ParticipantAgreementBO = new ParticipantAgreementTemplateBO();
  Release_of_InformationBO = new Release_of_InformationTemplateBO();
  application_Employer_Identification_NumberTemplateBO = new Application_Employer_Identification_NumberTemplateBO();
  payer_Appointment = new EmployerOrPayerAppointmentOfAgentTemplateBO();
  Individual_Sole_Proprietor_OfAttornyBO = new Individual_Sole_Proprietor_OfAttornyTemplateBO();
  Additional_AppointeeAddressBO = new Additional_AppointeeAddressTemplateBO();
  
  ssnbool1: boolean = false;
  ssnbool2: boolean = false;
  ssnbool3: boolean = false;
  ssnbool4: boolean = false;
  ssnbool5: boolean = false;
  ssnbool6: boolean = false;
  ssnbool7: boolean = false;
  ssnbool8: boolean = false;  

  snbool1: boolean = false;
  snbool2: boolean = false;
  snbool3: boolean = false;
  snbool4: boolean = false;
  snbool5: boolean = false;
  snbool6: boolean = false;
  snbool7: boolean = false;
  snbool8: boolean = false;

  phonerr: string[] = []
  phonerr1: string[] = []
  phonerr2: string[] = []
  ziperr: string[] = []
  errphone: boolean[] = []
  errphone1: boolean[] = []
  errphone2: boolean[] = []
  errZip: boolean[] = []

  bool1: boolean = false;
  bool2: boolean = false;
  bool3: boolean = false;
  bool4: boolean = false;

  documentTypeList: [{ Key: string, Value: string }];
  documentType: string = "";  
  Employeesign: string = ''
  Gurdiansign: string = ''
  sign: string = ''
  isedit: boolean = false
  public DocType: any;
  type_of_DocKey: string;
  IsduplicateForm: boolean = false;
  getId: string
  documentId: string
  signature: string = ''
  signhere1: string = ''
  signhere2: string = ''
  pantsign: string = ''
  pantsign1: string = ''
  Partisign: string = ''
  getdeleteid: string;
  
  initialPage: PageSettingsModel;
  public filterSettings: object;
  public data_1: Observable<DataStateChangeEventArgs>;
  isUpdate: boolean = false;  
  today = new Date();

  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  @ViewChild("EnrollmentsignaturePad") EnrollmentsignaturePad: SignaturePad;
  @ViewChild("EnrollPad") EnrollPad: SignaturePad;
  @ViewChild("Enroll") Enroll: SignaturePad;
  @ViewChild('YoursignaturePad') YoursignaturePad: SignaturePad;
  @ViewChild('AuthorizesignaturePad') AuthorizesignaturePad: SignaturePad;
  @ViewChild("signpadone") signpadone: SignaturePad;
  @ViewChild("signpadtwo") signpadtwo: SignaturePad;
  @ViewChild("userpad") userpad: SignaturePad;
  @ViewChild("Appointeepad") Appointeepad: SignaturePad;
  @ViewChild("Taxpayerpad") Taxpayerpad: SignaturePad;
  @ViewChild("Spousepad") Spousepad: SignaturePad;
  @ViewChild("Participantpad") Participantpad: SignaturePad;
  @ViewChild("pantpad") pantpad: SignaturePad;
  @ViewChild("pantpad1") pantpad1: SignaturePad;
  @ViewChild("powerpad") powerpad: SignaturePad;  

  public signaturePadOptions: Object = {

    'minWidth': 5,

    'canvasWidth': 500,

    'canvasHeight': 200,

    'maxWidth': 5,

    'penColor': "blue"

  };


  doctype = "";
  choose1 = "";
  choose2 = "";

  EducationColumn: boolean = false;
  @ViewChild('grid') public grid: GridComponent;
  arraycol: any = [];
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  isEditAgent: boolean;
  public filteroptions: object
  stateList: any = [];
  public staffingList = [];
  public selflist = []
  localdata: any = [];
  public formatOptions: object

  public payerform: FormGroup;
  public formss4: FormGroup;
  public agreementform: FormGroup;
  public releaseform: FormGroup;
  public indivualform: FormGroup;
  public form: FormGroup
  public form1: FormGroup
  public form2: FormGroup
  release = new Release_of_InformationTemplateBO();

  choose = [
    {
      name: "Self - HCSR"
    },
    { name: "Parent of Minor" },
    { name: "Guardian" }
  ]

  midd = [
    {
      name: "Self - HCSR"
    },
    { name: "Parent of Minor" },
    { name: "Guardian" }
  ]


  constructor(private fb: FormBuilder, public commonhttp: CommonHttpService, public general: GeneralService, 
    public clientservice: clienttemplateService, public toastrService: ToastrService, 
     public global: GlobalComponent, public datepipe: DatePipe, 
    public dateservice: DateService, public toastr: ToastrService) {

    this.form = this.fb.group({
      Designetele: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Designefax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      applitele: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      applifax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Identificationssn: ["", [Validators.minLength(9), Validators.maxLength(9)]],
    })

    this.form1 = this.fb.group({
      Payerzip1: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Payerphone1: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Payerzip2: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Payerphone2: ["", [Validators.minLength(14), Validators.maxLength(14)]],
    })

    this.form2 = this.fb.group({
      phone1: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax1: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      phone2: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax2: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax3: [""],
      phone3: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      phone4: [""],
      zip1: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      zip2: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      zip3: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      zip4: [""],
      ssn1: ["", [Validators.minLength(9), Validators.maxLength(9)]],
      ssn2: ["", [Validators.minLength(9), Validators.maxLength(9)]],
      Minnesota: [""]
    })

  }

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  ngOnInit(): void {
    let goal1 = new Additional_AppointeeAddressTemplateBO();
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.push(goal1);
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getstaffing();
    this.getself();
    this.getagencydetails();
    this.filterOptions = { type: 'Menu' }
    this.initialPage = { pageSizes: ['10', '20', '50'], pageSize: 10 }
    this.filteroptions = { type: 'date', format: 'MM/dd/yyyy' };

    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });

  }

  getagencydetails() {
    this.clientservice.GetAgencyDetails().subscribe((data: any) => {
      if (data) {
        this.prepolate.agentname = data.agencyName
        this.prepolate.adminstrartor = data.agencyName;
        this.prepolate.mail = data.agencyStreet != null ?data.agencyStreet : ''
        this.prepolate.address =data.agencyStreet != null ?data.agencyStreet:''
        this.prepolate.agentcity = data.agencyCity!=null?data.agencyCity:''
        this.prepolate.zip = data.agencyZipCode!=null?data.agencyZipCode:''
        this.prepolate.state = data.agencyState!=null?data.agencyState:''
        this.prepolate.mail = data.agencyStreet!=null?data.agencyStreet:''
        this.prepolate.city =  (data.agencyCity != null || data.agencyState != null || data.agencyZipCode != null) ? data.agencyCity + ',' + data.agencyState + ',' + data.agencyZipCode : '' + ',' + '' + ',' + ''
    
      }
      if(this.ClientTemplateBO?.datalist?.templateId!=undefined&&this.ClientTemplateBO?.datalist?.templateId!=null&&this.ClientTemplateBO?.datalist?.templateId!=''){
        this.getOnboarddata();
       }
    },
      (err: HttpErrorResponse) => {

        this.toastrService.error(err.error);
      }
    )
  }


  getstaffing() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "YESORNO");
      this.clientservice.gettype(params).subscribe((data: any) => {
        this.staffingList = data;

        this.staffingList.forEach(element => {
          element.Key = element.Key;

        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("Code", "YESORNO");
      this.clientservice.getcomman(params).subscribe((data: any) => {
        this.staffingList = data;
        this.staffingList.forEach(element => {
          element.Key = element.Key;
        });
      })
    }
  }

  getself() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "TPDESIGNEE");
      this.clientservice.gettype(params).subscribe((data: any) => {
        this.selflist = data;
        this.selflist.forEach(element => {
          element.Key = element.Key;
        });
      })
    }
    else {
      let params = new URLSearchParams();
      params.append("Code", "TPDESIGNEE");
      this.clientservice.getcomman(params).subscribe((data: any) => {
        this.selflist = data;
        this.selflist.forEach(element => {
          element.Key = element.Key;
        });
      })
    }
  }

  newdates(event, type, name) {
    if (type == "inputchange") {

      if (name == 'effdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate = val1;
        }
      }
      if (name == 'exdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date = val1;
        }
      }
      if (name == 'appdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date = val1;
        }
      }
      if (name == 'business') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted = val1;
        }
      }

      if (name == 'alien') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'effdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate = val1;
        }
      }
      if (name == 'exdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date = val1;

        }
      }

      if (name == 'appdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date = val1;
        }
      }

      if (name == 'business') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted = val1;
        }
      }

      if (name == 'alien') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid = val1;
        }
      }
    }
  }

  draw() {
    this.sign = this.Enroll.toDataURL();
  }

  ClearEmployeeSignature3() {
    this.Enroll.clear();
    this.sign = '';
  }
  FormCloseFun() {
    this.doctype = '';
  }

  dateFormateyyyyMMdd(date) {
    if (date != null) {
      let month = date.substring(0, 2);
      let day = date.substring(3, 5);
      let year = date.substring(6, 10);
      let days = +day;
      let months = +month;
      let years = +year;

      let newDate = new Date();
      newDate.setDate(days);
      newDate.setMonth(months - 1);
      newDate.setFullYear(years);
      return this.datepipe.transform(newDate, "yyyy-MM-dd")
    }
  }

  getOnboarddata() {
    let params = new URLSearchParams();
    params.append("documentLid",  this.ClientTemplateBO?.datalist?.templateId);

this.onboardClientDocument.iD=this.ClientTemplateBO?.datalist?.templateId
this.onboardClientDocument.documentLid=this.ClientTemplateBO?.datalist?.templateId

    this.clientservice.getonBoardAgency(params).subscribe((data: any) => {
      if (data) {
     this.onboardClientDocument.documentName=data.templateName;
        this.OnboardClientDocumentBO = data
        this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare =  data.release_of_InformationTemplateBO.authorizeBestCare?.toString() 
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc =  data.application_Employer_Identification_NumberTemplateBO.isapplicationLlc?.toString()
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates =data.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates?.toString();
          this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = data.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein?.toString()
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress = data.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress;
      }
    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.error);
      }
    )
  }

  close() {
    this.ClientTemplateBO.templateToOnboard = false;
    this.ClientTemplateBO.edit = false;
    this.dataEmitTemplate.emit(this.ClientTemplateBO)
  }

  gridListData: any = [];
  ContactColumn: boolean = false;

  CreateEvalue() {
    if (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.length > 0) {
      this.ContactColumn = true;
    }
    let list = new Additional_AppointeeAddressTemplateBO();
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.push(list);
  }

  removeSelectEvalue(Contact) {
    if (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.length > 1) {
      this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.splice(Contact, 1);
    }
  }

  save() {
        if (this.onboardClientDocument.iD == '00000000-0000-0000-0000-000000000000'||this.onboardClientDocument.iD == null||this.onboardClientDocument.iD == undefined) {
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != '' && this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != null && this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods != undefined) ? parseFloat(this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods.toString()) : null
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing != undefined) ? parseFloat(this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing.toString()) : null
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget != undefined) ? parseFloat(this.OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget.toString()) : null
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date = (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != '' && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != null && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare =  (this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare == 'true') ? true : (this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare == 'false') ? false : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc == 'true') ? true : (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc == 'false') ? false : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates == 'true') ? true : (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates == 'false') ? false : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'true') ? true : (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'false') ? false  : null;

        this.onboardClientDocument.iD = "00000000-0000-0000-0000-000000000000";
        
this.onboardClientDocument.documentName=this.ClientTemplateBO.templatename
        this.onboardClientDocument.documentLid = '00000000-0000-0000-0000-000000000000'
        this.onboardClientDocument.documentValue = this.OnboardClientDocumentBO

        this.clientservice.saveClientAgency(this.onboardClientDocument).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          if (data) {
            this.onboardClientDocument.iD=data;
            this.onboardClientDocument.documentLid=data;          
            this.toastr.success(' Document Saved ');
          }
        },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error);

          }
        )

      }

      else {
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != '' && this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != null && this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods != undefined) ? parseFloat(this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods.toString()) : null
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing != undefined) ? parseFloat(this.OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing.toString()) : null
        this.OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget != undefined) ? parseFloat(this.OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget.toString()) : null
        this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date = (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != '' && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != null && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
        this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare =  (this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare == 'true') ? true : (this.OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare == 'false') ? false : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc == 'true') ? true : (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc == 'false') ? false : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates == 'true') ? true : (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates == 'false') ? false : null;
        this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'true') ? true : (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'false') ? false  : null;
        this.onboardClientDocument.documentName=this.ClientTemplateBO.templatename
        this.onboardClientDocument.documentValue = this.OnboardClientDocumentBO
        this.clientservice.saveClientAgency(this.onboardClientDocument).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
         if (data) {
            this.toastr.success('Document updated ');
          }
        },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error);
          }
        )
      }
  }

  gettemplate() {

  }

  originaldata: any = []
  indit: boolean = false

  cleardropdown() {
    this.DocType = ""
    this.type_of_DocKey = ""
    this.isedit = false

    this.release = new Release_of_InformationTemplateBO();
    this.indivual = new Individual_Sole_Proprietor_OfAttornyTemplateBO();
    this.application = new Application_Employer_Identification_NumberTemplateBO();
    this.payer = new EmployerOrPayerAppointmentOfAgentTemplateBO();
    this.agreementBO = new ParticipantAgreementTemplateBO();
    this.Clear();
    this.Clear2();
    this.clearuser();
    this.clearParti();
    this.clearpant();  
    this.clearpant1();

  }

  DemographicPhoneFormat() {
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_telephone_number = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_telephone_number);
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_PhoneNumber = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_PhoneNumber);
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_FaxNumber = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_FaxNumber);
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicants_Telephone_Number = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicants_Telephone_Number);
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_Fax_Number = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_Fax_Number);
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicants_Fax_Number = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicants_Fax_Number);
    this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.agentDayTimePhone = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.agentDayTimePhone);
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.signPhoneNumber = this.general.converPhoneGoogleLib(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.signPhoneNumber);

    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.forEach(element => {
      element.phoneNumber = this.general.converPhoneGoogleLib(element.phoneNumber)
      element.faxNumber = this.general.converPhoneGoogleLib(element.faxNumber)
    })
  }

  here() {
    this.signhere1 = this.signpadone.toDataURL();   
  }

  here2() {
    this.signhere2 = this.signpadtwo.toDataURL();
  }

  Clear() {
    this.signpadone.clear();
    this.signhere1 = '';
  }

  Clear2() {
    this.signpadtwo.clear();
    this.signhere2 = '';
  }

  //form264//
 
  user() {
    this.signature = this.userpad.toDataURL();
  }

  clearuser() {
    this.userpad.clear();
    this.signature = '';    
  }

  pant() {
    this.pantsign = this.pantpad.toDataURL();
  }

  clearpant() {
    this.pantpad.clear();
    this.pantsign = '';    
  }

  Parti() {
    this.Partisign = this.powerpad.toDataURL();    
  }

  clearParti() {
    this.powerpad.clear();
    this.Partisign = '';
  }

  pant1() {
    this.pantsign1 = this.pantpad1.toDataURL();
  }

  clearpant1() {
    this.pantpad1.clear();
    this.pantsign1 = '';
  }

  
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  onClick() {
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods1 = '';
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Granted_Type_of_Tax1 = '';
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods2 = '';
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Granted_Type_of_Tax2 = '';
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods3 = '';
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Granted_Type_of_Tax3 = '';
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods4 = '';

  }

  clearparticipantbo() {
    this.OnboardClientDocumentBO.participantAgreementTemplateBO = new ParticipantAgreementTemplateBO();
    this.clearpant();
  }
  
  clearreleasebo() {
    this.OnboardClientDocumentBO.release_of_InformationTemplateBO = new Release_of_InformationTemplateBO();
    this.clearpant1();
  }
  clearapplicationbo() {
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO = new Application_Employer_Identification_NumberTemplateBO();
    this.clearuser();
  }
 
  clearpayerbo() {
    this.OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO = new EmployerOrPayerAppointmentOfAgentTemplateBO();
    this.Clear2();
    this.Clear();
  }
 
  clearindivualbo() {
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO = new Individual_Sole_Proprietor_OfAttornyTemplateBO();
    let goal1 = new Additional_AppointeeAddressTemplateBO();
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress.push(goal1);
    this.clearParti();
  }


  radio1() {
    this.ssnbool1 = true
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
    }

  radio2() {

    this.ssnbool2 = true
    this.ssnbool1 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
  }

  radio3() {

    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = true
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
  }

  radio4() {

    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = true
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
  }

  radio5() {
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = true
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
  }


  radio6() {
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = true
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
  }

  radio7() {

    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = true
    this.ssnbool8 = false
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
  }

  radio8() {

    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = true
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
  }

  event() {
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny = ''
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    }

  radiochange1(value) {
    if (value.target.checked == true) {
      this.snbool1 = true;
      this.snbool2 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange2(value) {
    if (value.target.checked == true) {
      this.snbool2 = true;
      this.snbool1 = false;
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange3(value) {
    if (value.target.checked == true) {
      this.snbool3 = true;
      this.snbool1 = false;
      this.snbool2 = false;
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange4(value) {
    if (value.target.checked == true) {
      this.snbool4 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange5(value) {
    if (value.target.checked == true) {
      this.snbool5 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''     
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange6(value) {
    if (value.target.checked == true) {
      this.snbool6 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool7 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange7(value) {
    if (value.target.checked == true) {
      this.snbool7 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool8 = false
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
      this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
      
    }
  }

  radioevent() {
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType = ''
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType = ''
    this.snbool1 = false
    this.snbool2 = false
    this.snbool3 = false
    this.snbool4 = false   
    this.snbool5 = false
    this.snbool6 = false
    this.snbool7 = false
    this.snbool8 = false
  }

  changeevent() {
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.othertext_16 = ''
    this.otherbool = false
  }

  otherbool: boolean = false;
  otherchange(value) {
    if (value != null || value != undefined || value != '') {
      this.otherbool = true
    }
    else {
      this.otherbool = false
    }

  }

  validchange1(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {


        this.errphone1[index] = true
        this.phonerr1[index] = 'Enter Valid phone, Enter 10 digit'
        this.bool2 = true

      }
      else {

        this.errphone1[index] = false
        this.phonerr1[index] = ''
        this.bool2 = false
      }
    } else {
      this.errphone1[index] = false
      this.bool2 = false
      this.phonerr1[index] = ''

    }

  }

  validchange2(index, val) {
    if (val.faxNumber != '' && val.faxNumber != null && val.faxNumber != undefined) {
      if (val.faxNumber.length != 14) {


        this.errphone2[index] = true
        this.phonerr2[index] = 'Enter Valid fax, Enter 10 digit'
        this.bool3 = true

      }
      else {

        this.errphone2[index] = false
        this.phonerr2[index] = ''
        this.bool3 = false
      }
    } else {
      this.errphone2[index] = false
      this.bool3 = false
      this.phonerr2[index] = ''

    }

  }

  validchange3(index, val) {
    if (val.zip != '' && val.zip != null && val.zip != undefined) {
      if (val.zip.length <= 4) {
        this.errZip[index] = true
        this.ziperr[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        this.bool4 = true
      }
      else {
        this.errZip[index] = false
        this.ziperr[index] = ''
        this.bool4 = false
      }
    } else {
      this.errZip[index] = false
      this.bool4 = false
      this.ziperr[index] = ''
    }

  }

  ngAfterContentChecked(){
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate = (this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != '' && this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != null && this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted = (this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != '' && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != null && this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted != undefined) ? (new Date(new Date(this.OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date = (this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != '' && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != undefined && this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date != null) ? this.datepipe.transform(this.OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date, "MM/dd/yyyy") : null;
  }

}
